import { makeEnvironmentProviders } from '@angular/core';
import { CommonHttpService } from './services';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

export function provideCueHttp() {
  return makeEnvironmentProviders([provideHttpClient(withInterceptorsFromDi()), CommonHttpService]);
}
